import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import * as actions from '../../../redux/actions/counterpartySearch';
import CounterpartySearchResult from '../../blocks/CounterpartySearchResult';
import CounterpartyInfo from '../../blocks/PageInfo/CounterpartyInfo';

import style from './CounterpartyContent.module.scss';
import CounterpartySearch from '../../blocks/Search/CounterpartySearch';

import { ICounterpartySearchResult } from '../../../redux/types/interfaces';
import api from '../../../helpers/api';
import getReferrerFrom from '../../../helpers/lib/getReferrerFrom';

interface IProps {
  SetCounterpartySearchResult: (payload: ICounterpartySearchResult) => void;
  slug: string;
  setCounterpartyErrors: Function;
}

const CounterpartyContent: React.FC<IProps> = ({
  SetCounterpartySearchResult,
  slug,
  setCounterpartyErrors,
}: IProps) => {
  const [showResult, setShowResult] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const search = useCallback(
    async (value) => {
      try {
        setShowResult(false);
        setIsLoading(true);
        setCounterpartyErrors('');
        const res = await fetch('/api/reports', {
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
          body: JSON.stringify({
            innOrOgrn: value,
          }),
        });
        if (res.status === 500) {
          setCounterpartyErrors('NOT_FOUND');
          return;
        }
        const result = await res.json();
        SetCounterpartySearchResult(result);
        setIsLoading(false);
        setShowResult(true);
      } catch (error: any) {
        setCounterpartyErrors(error.message);
      } finally {
        setShowResult(true);
        setIsLoading(false);

        await api.sendReport(api.API_CHECKING_COUNTERPARTY_REPORT_TYPE, {
          ...getReferrerFrom(),
          innOrOgrn: value,
        });
      }
    },
    [SetCounterpartySearchResult, setCounterpartyErrors],
  );

  useEffect(() => {
    if (slug) {
      search(slug);
    }
  }, [slug, search]);

  return (
    <div className={style.container}>
      <CounterpartyInfo />
      <CounterpartySearch onSubmit={search} slug={slug} />
      {isLoading && (
        <div className={style.spin}>
          <Spin />
        </div>
      )}
      {showResult && <CounterpartySearchResult />}
    </div>
  );
};

export default connect(null, actions)(CounterpartyContent);
